// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export const stmproductApi = api
  .enhanceEndpoints({ addTagTypes: ['STMProduct'] })
  .injectEndpoints({
    endpoints: builder => ({
      getSTMProducts: builder.query<po_mproduct[], string>({
        query: cid => `stmproduct/${cid}`,
        providesTags: ['STMProduct']
      }),
      getSTMProductById: builder.query<po_mproduct, string>({
        query: id => `stmproduct/byid/${id}`,
        providesTags: ['STMProduct']
      }),
      importSTMProduct: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `stmproduct/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['STMProduct']
      }),
      insertSTMProduct: builder.mutation({
        query: stmproduct => ({
          url: `stmproduct/`,
          method: 'POST',
          body: stmproduct
        }),
        invalidatesTags: ['STMProduct']
      }),
      updateSTMProduct: builder.mutation({
        query: stmproduct => ({
          url: `stmproduct/`,
          method: 'PUT',
          body: stmproduct
        }),
        invalidatesTags: ['STMProduct']
      }),
      updateSTMProductImage: builder.mutation<any, { pr_id: number; pr_image: string }>({
        query: body => ({
          url: `stmproduct/image`,
          method: 'PUT',
          body
        }),
        invalidatesTags: ['STMProduct']
      }),
      deleteSTMProduct: builder.mutation({
        query: stmproduct => ({
          url: `stmproduct/${stmproduct.pr_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['STMProduct']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTMProductsQuery,
  useGetSTMProductByIdQuery,
  useImportSTMProductMutation,
  useInsertSTMProductMutation,
  useUpdateSTMProductMutation,
  useUpdateSTMProductImageMutation,
  useDeleteSTMProductMutation
} = stmproductApi;

